import { type FC } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import useDestroySalaryRange from 'modules/job_catalog/hooks/useDestroySalaryRange'

interface Props {
  id: string
  onDeleted: () => void
  onClose: () => void
}

const DeleteSalaryRangeModal: FC<Props> = ({ id, onDeleted, onClose }) => {
  const { destroySalaryRange, isMutating } = useDestroySalaryRange()

  const handleClose = () => {
    onClose()
  }

  const handleSubmit = async () => {
    const result = await destroySalaryRange(id)
    const { success } = handleResult(result, () => undefined)

    if (success) {
      onDeleted()
    }
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('job_catalog.salary_ranges.delete_salary_range_modal.title')}
      description={i18n.t('job_catalog.salary_ranges.delete_salary_range_modal.description')}
      onSubmit={handleSubmit}
      onClose={handleClose}
      footer={
        <>
          <Button onClick={handleClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={isMutating} submit>
            {i18n.t('common.delete')}
          </Button>
        </>
      }
    />
  )
}

export default DeleteSalaryRangeModal
